import { GetPermitToDig_permitToDig } from "../operations/queries/__generated__/GetPermitToDig";
import { PermitToDigAllFields_fieldValues } from "../operations/fragments/__generated__/PermitToDigAllFields";
import { PermitToDigTrigger, PermitFieldValueInput } from "./globalTypes";

export interface Permit extends GetPermitToDig_permitToDig {}

export const triggerSavePermitted = (permit: Permit) => permit.permittedTriggers.includes(PermitToDigTrigger.SAVE);

export const triggerSubmitPermitted = (permit: Permit) => permit.permittedTriggers.includes(PermitToDigTrigger.SUBMIT);

export const triggerRejectPermitted = (permit: Permit) =>
  permit.permittedTriggers.includes(PermitToDigTrigger.REJECT_REQUEST);

export const triggerApprovePermitted = (permit: Permit) =>
  permit.permittedTriggers.includes(PermitToDigTrigger.APPROVE_REQUEST);

export const triggerRequestPermitted = (permit: Permit) =>
  permit.permittedTriggers.includes(PermitToDigTrigger.REQUEST);

export const triggerExtendPermitted = (permit: Permit) => permit.permittedTriggers.includes(PermitToDigTrigger.EXTEND);

export const triggerExpirePermitted = (permit: Permit) => permit.permittedTriggers.includes(PermitToDigTrigger.EXPIRE);

export const triggerCompletePermitted = (permit: Permit) =>
  permit.permittedTriggers.includes(PermitToDigTrigger.COMPLETE);

export const triggerCancelPermitted = (permit: Permit) => permit.permittedTriggers.includes(PermitToDigTrigger.CANCEL);

export const triggerUndoCancellationPermitted = (permit: Permit) =>
  permit.permittedTriggers.includes(PermitToDigTrigger.UNDO_CANCELLATION);

/** Maps raw GraphQL permit field values to PermitFieldValueInput, removing __typename. */
export function mapPermitFieldValues(fieldValues: PermitToDigAllFields_fieldValues[]): PermitFieldValueInput[] {
  return fieldValues.map((fv) => {
    const input: PermitFieldValueInput = { fieldKey: fv.fieldKey };
    if (fv.__typename === "TextPermitFieldValue") input.stringValue = fv.stringValue;
    if (fv.__typename === "BooleanPermitFieldValue") input.booleanValue = fv.booleanValue;
    if (fv.__typename === "NumberPermitFieldValue") input.numberValue = fv.numberValue;
    if (fv.__typename === "DatePermitFieldValue") input.dateValue = fv.dateValue;
    return input;
  });
}

